import { render, staticRenderFns } from "./PostFitOutGuidelineComment.vue?vue&type=template&id=6e0a04ee&scoped=true&"
import script from "./PostFitOutGuidelineComment.vue?vue&type=script&lang=js&"
export * from "./PostFitOutGuidelineComment.vue?vue&type=script&lang=js&"
import style0 from "./PostFitOutGuidelineComment.vue?vue&type=style&index=0&id=6e0a04ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0a04ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e0a04ee')) {
      api.createRecord('6e0a04ee', component.options)
    } else {
      api.reload('6e0a04ee', component.options)
    }
    module.hot.accept("./PostFitOutGuidelineComment.vue?vue&type=template&id=6e0a04ee&scoped=true&", function () {
      api.rerender('6e0a04ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/postFitOutLetter/PostFitOutGuidelineComment.vue"
export default component.exports